// Prompt the participant to reconnect when Plaid requires new credentials.
export const refreshPlaidLink = async (store, accountId) => {
  const result = await store.refreshPlaidAccount(accountId)
  if (result?.loginNeeded) {
    store.showToast({ severity: 'error', message: 'Please update your credentials.' })
  }
}
